<template>
    <div class="column-layout">
        <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler" :popupHandler="popupHandler" :eventHandler="eventHandler"></swb-query-sort-area>
        <div v-if="checkBox" class="table-layout">
            <el-table ref="multipleTable" :data="comList" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column v-if="checkBox" type="selection" :selectable="canSelectRow" width="55" align="center"></el-table-column>
                <el-table-column prop="bizUnitName" label="业务单元" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="业务部门" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orgType" label="机构类型" align="left" width="200" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.orgType == 0">业务部门</span>
                        <span v-if="rows.row.orgType == 1">业务单元</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="业务单元级别" align="center" width="100">
                    <template slot-scope="rows">
                        <span>{{ getTransComLevel(rows.row.bizUnitLevel) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="contactName" label="联系人" align="left" width="120"></el-table-column>
                <el-table-column prop="contactTel" label="联系电话" align="center" width="110"></el-table-column>
                <el-table-column label="地址" align="left" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.regionName != null">{{ rows.row.regionName }}</span>
                        <span v-if="rows.row.street != null">{{ rows.row.street }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-layout" v-else>
            <el-table ref="multipleTable" :data="comList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checkComInfo!= null && checkComInfo.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="bizUnitName" label="业务单元" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="业务部门" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orgType" label="机构类型" align="left" width="200" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.orgType == 0">业务部门</span>
                        <span v-if="rows.row.orgType == 1">业务单元</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="业务单元级别" align="center" width="100">
                    <template slot-scope="rows">
                        <span>{{ getTransComLevel(rows.row.bizUnitLevel) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="contactName" label="联系人" align="center" width="110"></el-table-column>
                <el-table-column prop="contactTel" label="联系电话" align="center" width="110"></el-table-column>
                <el-table-column label="地址" align="left" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.regionName != null">{{ rows.row.regionName }}</span>
                        <span v-if="rows.row.street != null">{{ rows.row.street }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    import {openRegionForSelectDlg} from '../comn/regionSelectDlg'
    import {transComLevel} from './struct-comn'

    import servicerApi from '../../api/servicer'

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "code": "bizUnitName",
            "label": "业务单元",
            "basic": true,
            "hidden": false
        }, {
            "type": "Text",
            "valueType": "String",
            "code": "name",
            "label": "业务部门",
            "basic": true,
            "hidden": false
        }, {
            "type": "Select",
            "valueType": "Integer",
            "code": "bizUnitLevel",
            "label": "业务单元级别",
            "basic": true,
            "dataList": [{
                "value": null,
                "label": "-全部-"
            }, {
                "value": "1",
                "label": "一级"
            }, {
                "value": "2",
                "label": "二级"
            }, {
                "value": "3",
                "label": "三级"
            }, {
                "value": "4",
                "label": "四级"
            }, {
                "value": "5",
                "label": "五级"
            }, {
                "value": "6",
                "label": "六级"
            }, {
                "value": "7",
                "label": "七级"
            }, {
                "value": "8",
                "label": "八级"
            }, {
                "value": "9",
                "label": "九级"
            }, {
                "value": "10",
                "label": "十级"
            }],
        }, {
            "type": "Select",
            "valueType": "Integer",
            "code": "orgType",
            "label": "机构类型",
            "basic": false,
            "dataList": [{
                "value": null,
                "label": "-全部-"
            }, {
                "value": "1",
                "label": "业务单元"
            }, {
                "value": "0",
                "label": "业务部门"
            }],
        }, {
            "type": "Popup",
            "valueType": "Integer",
            "label": "地区",
            "code": "regionId",
            "basic": true
        }],
        "sortFields": []
    };
    // 所有机构（网点）-扁平化选择
    export default {
        name: 'swb-servicer-com-list-for-select',
        desc: '服务商机构-选择',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            isCom: {
                type: Boolean,
                default: false
            },
            checkedComList: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            merchantId: {
                type: Number,
                default: null,
            },
            comId: {
                type: Number,
                default: null,
            },
            comLevel: {
                type: Number,
                default: null,
            },
            orgType: {
                type: Number,
                default: null,
            },
            shopFlag: {
                type: Boolean,
                default: null
            },
            disabledIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            bizUnitLevels: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            bizUnitType: {
                type: Number,
                default: null,
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                checkedTblRefId: 'multipleTable',
                checkedDelay: 100,
                checkedIniting: false,
                //
                comList: [],
                name: null,
                selectComList: [],
                selectComIds: [],
                checkComInfo: null,
                //
                //排序、搜索
                queryConfig: searchConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                provinceId: null,
                cityId: null,
                countyId: null,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.selectComList = Utils.merge([], this.checkedComList);
            //
            this.getServicerComList();
        },
        methods: {
            getTransComLevel: function (level) {
                return transComLevel(level);
            },
            queryHandler(queryModel) {
                if (this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = 1;
                this.queryModel = queryModel;
                //
                this.getServicerComList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if (this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getServicerComList();
            },
            // 根据不同信息变换查询信息
            popupHandler: function (fieldCode, curValue, curText) {
                let self = this;
                if (fieldCode == 'regionId') {
                    let params = {
                        provinceId: self.provinceId,
                        cityId: self.cityId,
                        countyId: self.countyId,
                    };
                    openRegionForSelectDlg(params, function (result) {
                        let query_model_ctrl = self.$refs['query_model_ctrl'];
                        let fieldInfo = {
                            regionId: {
                                value: result.regionId,
                                text: result.regionName
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                        self.provinceId = result.provinceId;
                        self.cityId = result.cityId;
                        self.countyId = result.countyId;
                    });
                }
            },
            eventHandler: function (itemCode, eventName, itemValue) {
                let queryFields = this.queryConfig.queryFields;
                if (eventName == 'change') {
                    //
                    if (itemCode == 'regionId' && Utils.isNoB(itemValue)) {
                        let regionItem = queryFields.find(function (field) {
                            return field.code == 'regionId';
                        });
                        //
                        regionItem.forcedValue = null;
                        regionItem.text = null;
                        this.provinceId = null;
                        this.cityId = null;
                        this.countyId = null;
                        //
                        this.queryConfig = Utils.merge({}, this.queryConfig);
                    }
                }
            },
            getServicerComList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if (Utils.isTrue(self.isCom)) {
                    filterItems.isCom = self.isCom;
                }
                filterItems.closed = false;
                if (!Utils.isNoB(self.merchantId)) {
                    filterItems.merchantId = self.merchantId;
                }
                //
                if (!Utils.isNoB(filterItems.regionId)) {
                    filterItems.regionId = null;
                    //
                    filterItems.provinceId = self.provinceId;
                    filterItems.cityId = self.cityId;
                    filterItems.countyId = self.countyId;
                }
                if (!Utils.isNoB(self.comId) && !Utils.isNoB(self.comLevel)) {
                    filterItems.comId = self.comId;
                    filterItems.comLevel = self.comLevel;
                }
                if (!Utils.isNoB(self.shopFlag)) {
                    filterItems.shopFlag = self.shopFlag;
                }
                if (!Utils.isNoB(self.bizUnitType)) {
                    filterItems.bizUnitType = self.bizUnitType;
                }
                if (!Utils.isNoB(self.bizUnitLevels) && self.bizUnitLevels.length > 0) {
                    filterItems.bizUnitLevels = self.bizUnitLevels;
                }
                if (!Utils.isNoB(self.orgType)) {
                    filterItems.orgType = self.orgType;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                servicerApi.getServicerComListByMerchantId(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let data = result.data;
                        self.comList = data.rows;
                        //
                        self.totalCount = result.data.pagination.totalCount;
                        //
                        // 处理回显
                        setTimeout(function () {
                            self.restoreSelRows(self.comList, self.checkedTblRefId, 'id');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp) {
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selectComIds = self.selectComList.pluck("id");
                let selIds = Utils.compareArrays(allIds, selectComIds)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },
            toggleListRowById(dataRows, tblRefId, idProp, idVal) {
                let self = this;
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if (theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            // 多选
            handleSelectionChange: function (selRows) {
                let self = this;
                if (self.checkedIniting) {
                    return;
                }
                let selectComIds = self.selectComList.pluck("id");
                let selectIds = Utils.merge([], selectComIds);
                let selectComList = Utils.merge([], this.selectComList);
                //
                let allIds = self.comList.pluck("id");
                let selIds = selRows.pluck("id");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index], selectIds, selectComList);
                });
                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id, selectIds, selectComList);
                });
                //
                this.$emit("handle-change", selectComList);
                this.selectComList = selectComList;
            },
            addCheckId: function (id, val, checkedIds, checkedList) {
                if (!checkedIds.contains(id)) {
                    checkedIds.add(id);
                    checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id, checkedIds, checkedList) {
                if (checkedIds.contains(id)) {
                    for (let i = 0; i < checkedList.length; i++) {
                        let checkedCom = checkedList[i];
                        if (checkedCom.id == id) {
                            checkedList.splice(i, 1);
                        }
                    }
                    checkedIds.remove(id);
                    return id;
                }
                return null;
            },
            // 单选
            handleCurrentChange: function (val) {
                this.checkComInfo = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if (checkBox) {
                    let selectComList = self.selectComList;
                    if (selectComList != null && selectComList.length > 0) {
                        result.type = "info";
                        result.data = selectComList;
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个机构！';
                    }
                } else {
                    let comInfo = self.checkComInfo;
                    if (comInfo != null) {
                        result.type = "info";
                        result.data = comInfo;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择机构！';
                    }
                }
                return result;
            },
            canSelectRow(row, index) {
                return !this.disabledIds.contains(row.id);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/orgStruct/ServicerComListForSelect.vue